(function ($) {

    var v = '0.0.1.20210417.01';

    if(window.pw !== undefined) {
        pw.doc('pwSelection', v, [
            '$(\'#foo\').pwSelection(\'upperCase\')',
            '$(\'#foo\').pwSelection(\'titleCase\')',
            '$(\'#foo\').pwSelection(\'lowerCase\')',
        ]);
    }


    function getInputSelection(el) {
        var start = 0, end = 0, normalizedValue, range,
            textInputRange, len, endRange;

        if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
            start = el.selectionStart;
            end = el.selectionEnd;
        } else {
            range = document.selection.createRange();

            if (range && range.parentElement() == el) {
                len = el.value.length;
                normalizedValue = el.value.replace(/\r\n/g, "\n");

                textInputRange = el.createTextRange();
                textInputRange.moveToBookmark(range.getBookmark());

                endRange = el.createTextRange();
                endRange.collapse(false);

                if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                    start = end = len;
                } else {
                    start = -textInputRange.moveStart("character", -len);
                    start += normalizedValue.slice(0, start).split("\n").length - 1;

                    if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                        end = len;
                    } else {
                        end = -textInputRange.moveEnd("character", -len);
                        end += normalizedValue.slice(0, end).split("\n").length - 1;
                    }
                }
            }
        }

        return {
            start: start,
            end: end
        };
    }

    function replaceSelectedText(el, filter) {

        var sel = getInputSelection(el), val = el.value;
        var selText = val.slice(sel.start, sel.end);

        if (typeof filter == 'function') {
            selText = filter(selText);
        }
        if (typeof filter == 'string') {
            selText = filter;
        }

        console.log('replace', selText);
        el.value = val.slice(0, sel.start) + selText + val.slice(sel.end);
    }

    var methods = {
        init : function(options) {

        },
        replace : function( filter ) {
            replaceSelectedText(this[0], filter)
        },
        lowerCase : function( ) {
            replaceSelectedText(this[0], function(s) {
                if (typeof s !== 'string') return ''
                return s.toLocaleLowerCase()
            });
            return this;
        },
        titleCase : function( ) {
            replaceSelectedText(this[0], function(s) {
                if (typeof s !== 'string') return ''
                s = s.toLocaleLowerCase()
                return s.charAt(0).toLocaleUpperCase() + s.slice(1)
            });
            return this;
        },// GOOD
        upperCase : function( ) {
            replaceSelectedText(this[0], function(s) {
                if (typeof s !== 'string') return ''
                return s.toLocaleUpperCase()
            });
            return this;
        },
        info : function( content ) {
            return getInputSelection(this[0]);
        }
    };

    $.fn.pwSelection = function(methodOrOptions) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist on jQuery.tooltip' );
        }
    };

})(jQuery);